import {
  Dialog, DialogContent, DialogTitle, Grid, Paper, styled, Table, TableBody, TableCell,
  tableCellClasses, TableContainer, TableHead, TablePagination, TableRow, Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import BillingReportsService from "../../../Services/Reports/BillingReportsService";
import Home from "../../home/Home";
import Snackbar from '../../Snacbar'
import { getUserId } from '../../Utils/Common';
import HashLoader from "react-spinners/HashLoader";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(61, 195, 177)',
    color: 'black',
    textAlign: "center",
    fontFamily: 'Times New Roman',
    fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 14,
    fontFamily: 'Times New Roman',
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    // backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: " 1px solid black",
  // backgroundColor: "#C8EDE7",
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  border: " 1px solid black",
  backgroundColor: "white",
}));

function InvoiceBillDownload() {
  const mystyle = {
    border: " 1px solid black",
    width: "10rem", fontFamily: 'Times New Roman',textTransform:"uppercase"
  };
  const mystyle1 = {
    fontWeight: "bolder",
    color: "#0b64c5", fontFamily: 'Times New Roman',
  };

  ///setdetails
  const [message, setMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [severit, setseverit] = useState('');
  const [loading, setloading] = useState(false)
  const [details1, setdetails1] = useState([]);
  const [details2, setdetails2] = useState([]);
  const [details3, setdetails3] = useState([]);
  const [details4, setdetails4] = useState([]);
  const [details5, setdetails5] = useState([]);
  const [details6, setdetails6] = useState([]);
  const [FilteredDetails, setFilteredDetails] = useState([])
  const [crncyDis, setcrncyDis] = useState(false)
  const [getbankDis, setgetbankDis] = useState(false)
  const [DownloadBillopen, setDownloadBillopen] = useState(false);
  const [BillPrintAlertopen, setBillPrintAlertopen] = useState(false);
  const [singlejobsummaryOpen, setsinglejobsummaryOpen] = useState(false);
  const [radiovalue, setradiovalue] = useState("1");
  const [airlinse, setAirlinse] = useState(true);
  const [firstCarrier, setFirstCarrier] = useState(true);
  const [mode_ofAWB, setMode_ofAWB] = useState(true);
  const [shiper_hide, setShiper_hide] = useState(true);
  const [dwmldbillDis, setdwmldbillDis] = useState(true)
  const [showProcs, setshowProcs] = useState(false)
  const [refreshProcs, setrefreshProcs] = useState(false)
  const [dwnldBillCopyProcs, setdwnldBillCopyProcs] = useState(false)
  const [invcpy_values, setinvcpy_values] = useState({
    jobBIllNo: '',
    printto: '-1',
    operationtype: '',
    vouchertype: '-1',
    ///summaryvalues
    totalJobNo: '0',
    taxablevalue: '0.00',
    cgstAmt: '0.00',
    sgstAmt: '0.00',
    igstAMt: '0.00',
    totalAMt: '0.00',
    vessel_Airlines:'',
    firstCarrier_Volume:'',
    modeOf_AWB:'',
    mode:'',
    shipperINVno:'',
    shipperINVdate:''
  })
  const [error, setError] = useState({
    jobBIllNo: false
  })
  const [invcpyDialog_values, setinvcpyDialog_values] = useState({
    dia_bankId: '',
    currencycode: '',
    exchangecode: '',
    ///singlejobsummaryvalues
    dia_taxablevalue: '0.00',
    dia_sgstAmt: '0.00',
    dia_cgstAmt: '0.00',
    dia_igstAMt: '0.00',
    dia_totalBillAmt: '0.00',
    bill_type:null
  });

  // onchange=======>
  const jobBillhandlechange = (e) => {
    setinvcpy_values({ ...invcpy_values, jobBIllNo: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const AirVesselhandlechange = (e) => {
    setinvcpy_values({ ...invcpy_values, vessel_Airlines: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const FirstCarrier_Volhandlechange = (e) => {
    setinvcpy_values({ ...invcpy_values, firstCarrier_Volume: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const modeOfAWBhandlechange = (e) => {
    setinvcpy_values({ ...invcpy_values, modeOf_AWB: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const printtohandlechange = (e) => {
    setinvcpy_values({ ...invcpy_values, printto: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const vouchertypehandlechange = (e) => {
    setinvcpy_values({ ...invcpy_values, vouchertype: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const ShipperInvNohandlechange = (e) => {
    setinvcpy_values({ ...invcpy_values, shipperINVno: e.target.value.replace(/[`~!@#$%^?'"<>]/gi, '') })
  };
  const ShipperInvDateHandlechange = (e) => {
    setinvcpy_values({ ...invcpy_values, shipperINVdate: e.target.value})
  };
  const radiovalueOnchange = (e) => {
    setinvcpy_values({
      ...invcpy_values, jobBIllNo: '', totalJobNo: '0', taxablevalue: '0.00', cgstAmt: '0.00', sgstAmt: '0.00',
      igstAMt: '0.00', totalAMt: '0.00',
    })
    setdetails1([])
    setFilteredDetails([])
    setPage(0)
    setradiovalue(e.target.value)
  };
  ///dialogbox onchange===>
  const currencycodeOnchange = (e) => {
    const filtervalue = details3.find((node) => node.currency_code === e.target.value);
    if (invcpy_values.operationtype === 'IMPORT') {
      setinvcpyDialog_values({ ...invcpyDialog_values, currencycode: e.target.value, exchangecode: filtervalue.importExchangeRate })
    }
    else {
      setinvcpyDialog_values({ ...invcpyDialog_values, currencycode: e.target.value, exchangecode: filtervalue.exportExchangeRate })
    }
  }
  const exchangecodeOnchange = (e) => {
    setinvcpyDialog_values({ ...invcpyDialog_values, exchangecode: e.target.value })
  }
  const BankId_OnChange = (e) => {
    setinvcpyDialog_values({ ...invcpyDialog_values, dia_bankId: e.target.value })
  }
  // const Bill_type_OnChange = (e) => {
  //   setinvcpyDialog_values({ ...invcpyDialog_values, bill_type: e.target.value })
  // }
  //keydown
  const jobNokeydown = (e) => {
    if (e.key === 'Enter') {
      document.getElementById('billprintTo').focus()
    }
  }
  //
  const getBankName = () => {
    BillingReportsService.getBankName().then((res) => {
      setdetails6(res.data)
    })

  }

  const shipmentValidate=()=>{
    if(invcpy_values.vessel_Airlines===''||!invcpy_values.vessel_Airlines){
      setMessage(ShipmentTitl()+' name missigng')
      setseverit('error')
      setOpen(true)
    }else{
      if(invcpy_values.firstCarrier_Volume===''||!invcpy_values.firstCarrier_Volume){
        setMessage(ShipmentVolFirst()+' name missigng')
        setseverit('error')
        setOpen(true)
      }else{
        if(invcpy_values.mode==='AIR'){
        if(invcpy_values.modeOf_AWB===''||!invcpy_values.modeOf_AWB){
          setMessage('mode of AWB is missigng')
          setseverit('error')
          setOpen(true)
        }else{
          return true;
        }
      }else{
        return true;
      }
      }
    }
    return false;
  }
// const [getbillType, setBillType] = useState([])
  ///dialog box open close
  const downldBillhandleClickOpen = () => {
    if(shipmentValidate()===true){
    setdwnldBillCopyProcs(true)
    setDownloadBillopen(true);
    getBankName()
    BillingReportsService.getCurrencyName().then(res => {
      setdetails3(res.data);
    })
    // BillingReportsService.getBill_type().then(res => {
    //   setBillType(res.data);
    // })
    var airlines='';var firstCarriar ='';var vessel='';var volume = '';
    if(invcpy_values.mode==='AIR'){
      airlines=invcpy_values.vessel_Airlines
      firstCarriar=invcpy_values.firstCarrier_Volume
    }else{
      vessel=invcpy_values.vessel_Airlines
      volume=invcpy_values.firstCarrier_Volume
    }
    let details = {consignment_no:invcpy_values.jobBIllNo,airlines_name:airlines,shipperinvoiceno:invcpy_values.shipperINVno,shipperinvoicedate:invcpy_values.shipperINVdate
      ,first_carrier_name:firstCarriar ,mode_of_awb:invcpy_values.modeOf_AWB,vessel_name:vessel , volume:volume ,equipment_size:' '}

    BillingReportsService.insertShipment_mode_details(details).then((res)=>{
      const datamsg = res.data;
      setMessage(datamsg.message.toString())
      setseverit('success')
      setOpen(true)
      setshowProcs(false)
      setloading(false)
    })
    BillingReportsService.getJobCurrencyDetails(invcpy_values.jobBIllNo).then(res => {
      const data = res.data;
      const details = data.map((trns) => trns)
      var currencycode, exchangecode, dia_bankId = '';
      if (details[0] !== '') {
        if (details[0].currency_code !== '' && details[0].currency_code !== null && details[0].currency_code !== undefined) {
          currencycode = details[0].currency_code;
          exchangecode = details[0].exchangeRate;
          setcrncyDis(true)
        } else {
          currencycode = 'INR';
          exchangecode = '1.00';
          setcrncyDis(false)
        }
        if (invcpyDialog_values.dia_bankId !== '' && invcpyDialog_values.dia_bankId !== null && invcpyDialog_values.dia_bankId !== undefined) {
          dia_bankId = details[0].bank_id;
          setgetbankDis(true)
        } else {
          dia_bankId = '1';
          setgetbankDis(false)
        }
        setinvcpy_values({ ...invcpy_values, operationtype: details[0].operationType });
        setinvcpyDialog_values({ ...invcpyDialog_values, currencycode: currencycode, exchangecode: exchangecode, dia_bankId: dia_bankId })
      }
      else {
        setinvcpyDialog_values({ ...invcpyDialog_values, currencycode: '', exchangecode: '0', dia_bankId: '' })
        getBankName()
        setcrncyDis(false)
        setgetbankDis(false)
      }
    })
    setdwnldBillCopyProcs(false)
  }
  };
  const downldBillhandleClickClose = () => {
    setDownloadBillopen(false);
  };

  const Singlejobsummaryopen = () => {
    setsinglejobsummaryOpen(true)
  }
  const Singlejobsummaryclose = () => {
    setsinglejobsummaryOpen(false)
  }
  //error box
  const handleClose = () => {
    setOpen(false)
  }

  ////clearsummary===>
  const clearsummary = () => {
    setinvcpy_values({
      ...invcpy_values, totalJobNo: '0', taxablevalue: '0.00', cgstAmt: '0.00', sgstAmt: '0.00',
      igstAMt: '0.00', totalAMt: '0.00',
    })
  }
  const clearsingleJobsummary = () => {
    setinvcpyDialog_values({
      ...invcpyDialog_values, dia_taxablevalue: '0.00', dia_sgstAmt: '0.00', dia_cgstAmt: '0.00', dia_igstAMt: '0.00', dia_totalBillAmt: '0.00'
    })
  }
  /// services=====================================================>
  ///////Bill print to 
  const getBillprintTo = () => {
    BillingReportsService.getBillPrintTo().then(res => {
      setdetails2(res.data);
    })
  }
  const getVoucherTypeAll = () => {
    BillingReportsService.getVoucherTypeAll().then(res => {
      setdetails5(res.data);
    })
  }
  ////
  const validate1 = () => {
    if (invcpy_values.jobBIllNo !== '') {
      return true;
    } else {
      document.getElementById('jobBillId').focus();
      setError({ ...error, jobBIllNo: true })
      setMessage('Please Enter the ' + gettitle() + '..!!')
      setseverit('warning')
      setOpen(true)
      setshowProcs(false)
      setloading(false)
    }
    return false;
  }
  /// Button services
  const showBTnOpen = () => {
    setloading(true)
    setshowProcs(true)
    setFilteredDetails([])
    setPage(0)
    clearsummary();
    clearsingleJobsummary();
    if (validate1() === true) {
      var cmid, invoiceno, flagbill = '';
      if (radiovalue === '1') {
        cmid = invcpy_values.jobBIllNo
        invoiceno = '-1'
        flagbill = 1
      } else {
        cmid = 1
        invoiceno = invcpy_values.jobBIllNo
        flagbill = 2
      }
      let details = { consignmentId: cmid, invoiceNo: invoiceno, flagbill: flagbill, voucherType: invcpy_values.vouchertype }
      BillingReportsService.reportJobBillDetails(details).then(res => {
        const data = res.data;
        const details = data.map((item) => item);
        if (details[0] === ''|| !details[0]) {
          setMessage('No Data Found!!')
          setseverit('warning')
          setOpen(true)
          setshowProcs(false)
          setloading(false)
        } else {
          setError({ ...error, jobBIllNo: false })
          let details2 = {consignment_no:invcpy_values.jobBIllNo}
          BillingReportsService.getShipment_mode_details(details2).then((res1)=>{
            const data2 = res1.data;
            const detailsData = data2.map((item)=>item)
            var airlines ='';var firstCarrier='';var mode_Of_awb=''; 
            if (detailsData[0] === '' || !detailsData[0]) {
              setMessage('No Data Found!!')
              setseverit('warning')
              setOpen(true)
              setshowProcs(false)
              setloading(false)
            } else {
            if(details[0].shipmentMode==='AIR'){
              airlines=detailsData[0].airlines_name;
              firstCarrier=detailsData[0].first_carrier_name;
              mode_Of_awb=detailsData[0].mode_of_awb;
            }else{
              airlines=detailsData[0].vessel_name;
              firstCarrier=detailsData[0].volume;
            }
          }
            setinvcpy_values({
              ...invcpy_values, totalJobNo: details[0].serialNumber, taxablevalue: details[0].billAmount.toFixed(2), cgstAmt: details[0].cgstAmt.toFixed(2),
              sgstAmt: details[0].sgstAmt.toFixed(2), igstAMt: details[0].igstAmt.toFixed(2), totalAMt: details[0].totalBillAmount.toFixed(2),mode:details[0].shipmentMode,
              vessel_Airlines:airlines,firstCarrier_Volume:firstCarrier,modeOf_AWB:mode_Of_awb,shipperINVno:detailsData[0].shipperinvoiceno,shipperINVdate:detailsData[0].shipperinvoicedate
            })
          })
          setShiper_hide(false);
          if(details[0].shipmentMode==='AIR'){
            setAirlinse(false);
            setFirstCarrier(false);
            setMode_ofAWB(false)
          }else{
            setAirlinse(false);
            setFirstCarrier(false);
            setMode_ofAWB(true)
          }
          setError({ ...error, jobBIllNo: false })
          setdetails1(res.data)
          setFilteredDetails(res.data)
          setdwmldbillDis(false)
          setshowProcs(false)
          setloading(false)
        }
      })
    
    }
  }
  ///
  const RefreshBtn = () => {
    setPage(0)
    setrefreshProcs(true)
    setdwmldbillDis(true)
    setinvcpy_values({
      ...invcpy_values, jobBIllNo: '', printto: '-1', totalJobNo: '0', taxablevalue: '0.00', cgstAmt: '0.00',
      sgstAmt: '0.00', igstAMt: '0.00', totalAMt: '0.00', operationtype: '', vouchertype: '-1',shipperINVno:'',shipperINVdate:'',
      modeOf_AWB:'',vessel_Airlines:'',firstCarrier_Volume:''
    })
    setinvcpyDialog_values({
      ...invcpyDialog_values, dia_bankId: '', currencycode: '', exchangecode: '',
      dia_taxablevalue: '0.00', dia_sgstAmt: '0.00', dia_cgstAmt: '0.00', dia_igstAMt: '0.00', dia_totalBillAmt: '0.00',
    })
    setShiper_hide(true);
    setAirlinse(true);
    setFirstCarrier(true);
    setMode_ofAWB(true)
    setradiovalue('1');
    setError({ ...error, jobBIllNo: false })
    setdetails1([])
    setshowProcs(false)
    setFilteredDetails([])
    setrefreshProcs(false)
  }

  ///
  const exportOnClick = (action) => {
    var currencycd, exchangeRT, bankId = '';
    if (invcpyDialog_values.currencycode !== '') {
      currencycd = invcpyDialog_values.currencycode;
    } else {
      currencycd = 'INR'
    }
    if (invcpyDialog_values.exchangecode !== '' || invcpyDialog_values.exchangecode !== '0') {
      exchangeRT = invcpyDialog_values.exchangecode;
    } else {
      exchangeRT = 1.00
    }
    if (invcpyDialog_values.dia_bankId === null || invcpyDialog_values.dia_bankId === '' || invcpyDialog_values.dia_bankId === undefined) {
      bankId = '1'
    }
    else {
      bankId = invcpyDialog_values.dia_bankId;
    }
    let details = { consignmentId: invcpy_values.jobBIllNo, currency_code: currencycd, exchangeRate: exchangeRT, updatedBy: getUserId(), bankId: bankId }
    BillingReportsService.updateCurrencyRate(details).then(res => {
      exportGstBill(action)
      // setdetails4(res.data);
    })
  }

  const BillPrintAlerthandeler=(action)=>{
    exportOnClick(action);
  }

  const printAlertClickOpen=()=>{
    setBillPrintAlertopen(true)
     
  }
  const printAlertClickClose=()=>{
    setBillPrintAlertopen(false)
  }

  const exportGstBill = (action) => {
    if (radiovalue === '1') {
      getgstno(action)
    } else {
      invoiceBillPdfPrint(action)
    }
  }
  const getgstno = (action) => {
    if (invcpy_values.jobBIllNo !== '') {
      var jobNo = invcpy_values.jobBIllNo
      BillingReportsService.getGstNo(jobNo).then(res => {
        const details = res.data;
        if (details[0].firstLevelVerification === 1 && details[0].secondLevelVerification === 1) {
          invoiceBillPdfPrint(action);
        } else {
          setMessage('First and Second level Verification does not complete yet","Alert')
          setseverit('warning')
          setOpen(true)
        }
      })
    } else {
      setMessage("Kindly enter the Job No")
      setseverit('warning')
      setOpen(true)
    }
  }
  const invoiceBillPdfPrint = (action) => {
    var billby, consignmentid, billprint, flagBill = '';
    if (radiovalue === '1') {
      consignmentid = invcpy_values.jobBIllNo;
      billprint = '-1'
      flagBill = 1
    } else {
      consignmentid = -1;
      billprint = invcpy_values.jobBIllNo
      flagBill = 2
    }
    if (invcpy_values.printto === 'IMPORTER' || invcpy_values.printto === 'EXPORTER') {
      billby = '1'
    } else {
      billby = '2'
    }
    let details = {
      consignmentId: consignmentid, billNo: billprint, flagbill: flagBill, createdBy: getUserId(), voucherType: invcpy_values.vouchertype,billType:null,
      iecNo: '-1', fwdcode: '-1', billPaidBy: "SCOPE", billBy: billby, fileName: invcpy_values.jobBIllNo,logoFlag:action, shipmentMode: invcpy_values.mode
          }
    BillingReportsService.InvoiceBillPdfPrint(details).then((res) => {
      const filename = res.data.message;
      // window.open('D:/FemtoProjectFiles/java/spring_workspace/ExportFile/' + filename.toString(), "_blank");
      window.open('http://35.154.221.117:8081/ExportFiles/' + filename.toString(), "_blank");
    })
  }

  const SinglejobsummaryAssign = (trns) => {
    Singlejobsummaryopen();
    clearsingleJobsummary();
    let details = { consignmentId: trns.consignmentId, voucherType: invcpy_values.vouchertype }
    BillingReportsService.reportJobDetails(details).then(res => {
      const data = res.data;
      const details = data.map((item) => item);
      var taxableValue = 0, cgstAmt = 0, sgstAmt = 0, igstAmt = 0, totaAmt = 0;
      for (let i = '0'; i < details.length; i++) {
        taxableValue += details[i].taxableValue;
        cgstAmt += details[i].cgstAmt;
        sgstAmt += details[i].sgstAmt;
        igstAmt += details[i].igstAmt;
        totaAmt = igstAmt + taxableValue + cgstAmt + sgstAmt;
      }
      setinvcpyDialog_values({
        ...invcpyDialog_values, dia_taxablevalue: taxableValue.toFixed(2), dia_sgstAmt: sgstAmt.toFixed(2),
        dia_cgstAmt: cgstAmt.toFixed(2), dia_igstAMt: igstAmt.toFixed(2), dia_totalBillAmt: totaAmt.toFixed(2)
      })
      setdetails4(res.data)
    })
  }
  const gettitle = () => {
    if (radiovalue === '1') {
      return 'Job No';
    } else {
      return 'Bill No'
    }
  }
  const ShipmentTitl = () => {
    if (invcpy_values.mode === 'AIR') {
      return 'Airlines';
    } else {
      return 'Vessel'
    }
  }
  const ShipmentVolFirst = () => {
    if (invcpy_values.mode === 'AIR') {
      return 'First_Carrier Name';
    } else {
      return 'Volume'
    }
  }
  //serach table
  const jobnoSrch = () => {
    return <input style={{ width: '60px', textAlign: 'center', fontSize: '12px' }} placeholder="Search" onChange={(e) => { jobnoSearchOnchange(e.target.value) }} />
  }
  const gstBillNoSrch = () => {
    return <input style={{ width: '80px', textAlign: 'center', fontSize: '12px' }} placeholder="Search" onChange={(e) => { billnoSearchOnchange(e.target.value) }} />
  }
  const importerSrch = () => {
    return <input style={{ width: '90px', textAlign: 'center', fontSize: '12px' }} placeholder="Search" onChange={(e) => { impNameSearchOnchange(e.target.value) }} />
  }
  const modeSrch = () => {
    return <input style={{ width: '60px', textAlign: 'center', fontSize: '12px' }} placeholder="Search" onChange={(e) => { modeSearchOnchange(e.target.value) }} />
  }
  const jobnoSearchOnchange = (searchedVal) => {
    const filteredvalue = details1.filter((trns) => {
      return trns.consignmentId.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details1)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const billnoSearchOnchange = (searchedVal) => {
    const filteredvalue = details1.filter((trns) => {
      return trns.invoiceNo.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details1)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const impNameSearchOnchange = (searchedVal) => {
    const filteredvalue = details1.filter((trns) => {
      return trns.iecName.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details1)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  const modeSearchOnchange = (searchedVal) => {
    const filteredvalue = details1.filter((trns) => {
      return trns.transitMode.toString().toLowerCase().includes(searchedVal.toLowerCase())
    })
    if (filteredvalue.length < 1) {
      setFilteredDetails(details1)
    } else {
      setFilteredDetails(filteredvalue)
    }
  }
  useEffect(() => {
    setloading(true)
    setTimeout(() => {
      setloading(false)
    }, 1000)
    getBillprintTo();
    getVoucherTypeAll()
  }, []);

  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }
  return (
    <div>
      <div>
        <Dialog open={DownloadBillopen} onClose={downldBillhandleClickClose}>
        <Dialog open={BillPrintAlertopen} onClose={printAlertClickClose}>
        <DialogContent style={mystyle1}>
            {"Print Preferences"}
          {/* </DialogTitle>   
          <DialogContent> */}
            <center>
              <Button size="sm" variant="outline-primary" onClick={()=>BillPrintAlerthandeler(1)}>WithLogo</Button>{'  '}
              <Button size="sm" variant="outline-primary" onClick={()=>BillPrintAlerthandeler(2)}>WithOut Logo</Button>
            </center>
            </DialogContent> 
        </Dialog>
          <DialogTitle style={mystyle1}>
            {"Currency Updation"}
          </DialogTitle>
          <DialogContent>
            <div >
              <label>Currency Code</label>
              <Form.Select value={invcpyDialog_values.currencycode} onChange={currencycodeOnchange} disabled={crncyDis}>
                <option value={''}> </option>
                {details3.map((trns) => (
                  <option value={trns.currency_code}>{trns.currency_code}</option>
                ))}
              </Form.Select>
              <label>Exchange Rate</label>
              <Form.Control disabled={crncyDis} value={invcpyDialog_values.exchangecode} onChange={exchangecodeOnchange} />

              <label>Bank Name</label>
              <Form.Select disabled={getbankDis} value={invcpyDialog_values.dia_bankId} onChange={BankId_OnChange}>
                <option value={''}>---select---</option>
                {details6.map(trns => (
                  <option value={trns.bank_id}>{trns.bankName}</option>
                ))}
              </Form.Select>
              {/* <label>Bill Type</label>
              <Form.Select value={invcpyDialog_values.bill_type} onChange={Bill_type_OnChange}>
                <option value={''}>---select---</option>
                {getbillType.map(trns => (
                  <option value={trns.billType}>{trns.billType}</option>
                ))}
              </Form.Select> */}

              <center className='mt-2 mb-1'><Button onClick={printAlertClickOpen}>Export</Button></center>
            </div>
          </DialogContent>
        </Dialog>

        {/* //singlejob_summarydialogbox */}
        <Dialog open={singlejobsummaryOpen} onClose={Singlejobsummaryclose} maxWidth>
          <DialogTitle className="bg-info p-1"><center>Bill details</center></DialogTitle>
          <div>
            <ItemPap>
              <lable style={{ fontWeight: 'bold', color: 'red' }}>Summary</lable>
              <Row>
                <Col><Form.Label style={{ fontFamily: 'Times New Roman', color: "black", fontWeight: "bolder", }}>Taxable Value :</Form.Label>
                  <Form.Label style={{ fontFamily: 'Times New Roman', color: "red", fontWeight: "bolder", }}>{invcpyDialog_values.dia_taxablevalue}</Form.Label></Col>

                <Col><Form.Label style={{ fontFamily: 'Times New Roman', color: "black", fontWeight: "bolder", }}>SGST Amount :</Form.Label>
                  <Form.Label style={{ fontFamily: 'Times New Roman', color: "red", fontWeight: "bolder", }}>{invcpyDialog_values.dia_sgstAmt}</Form.Label></Col>
              </Row>
              <Row>
                <Col><Form.Label style={{ fontFamily: 'Times New Roman', color: "black", fontWeight: "bolder", }}>CGST Amount :</Form.Label>
                  <Form.Label style={{ fontFamily: 'Times New Roman', color: "red", fontWeight: "bolder", }}>{invcpyDialog_values.dia_cgstAmt}</Form.Label></Col>

                <Col><Form.Label style={{ fontFamily: 'Times New Roman', color: "black", fontWeight: "bolder", }}>IGST Amount :</Form.Label>
                  <Form.Label style={{ fontFamily: 'Times New Roman', color: "red", fontWeight: "bolder", }}>{invcpyDialog_values.dia_igstAMt}</Form.Label></Col>
              </Row>
              <Row>
                <Col><Form.Label style={{ fontFamily: 'Times New Roman', color: "black", fontWeight: "bolder", }}>Total Bill Amount:</Form.Label>
                  <Form.Label style={{ fontFamily: 'Times New Roman', color: "red", fontWeight: "bolder", }}>{invcpyDialog_values.dia_totalBillAmt}</Form.Label></Col>
              </Row>
              <TableContainer sx={{ fontFamily: 'Times New Roman', height: '250px' }} className='scrollbarPrime'>
                <Table stickyHeader className='table table-bordered-dark border-dark table table-bordered'>
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell style={{ textAlign: 'center' }}>Sl.No</StyledTableCell>
                      <StyledTableCell style={{ textAlign: 'center' }}>JobNo</StyledTableCell>
                      <StyledTableCell style={{ textAlign: 'center' }}>Description</StyledTableCell>
                      <StyledTableCell style={{ textAlign: 'center' }}>HSN_Code</StyledTableCell>
                      <StyledTableCell style={{ textAlign: 'center' }}>TaxableValue</StyledTableCell>
                      <StyledTableCell style={{ textAlign: 'center' }}>NonTaxableValue</StyledTableCell>
                      <StyledTableCell style={{ textAlign: 'center' }}>CGSTRate</StyledTableCell>
                      <StyledTableCell style={{ textAlign: 'center' }}>CGSTAmount</StyledTableCell>
                      <StyledTableCell style={{ textAlign: 'center' }}> SGST_RATE</StyledTableCell>
                      <StyledTableCell style={{ textAlign: 'center' }}>SGST_Amount</StyledTableCell>
                      <StyledTableCell style={{ textAlign: 'center' }}>IGST_Rate</StyledTableCell>
                      <StyledTableCell style={{ textAlign: 'center' }}>IGST_Amount</StyledTableCell>
                      <StyledTableCell style={{ textAlign: 'center' }}>TotalBillAmount</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {details4.map((trns) => (
                      <StyledTableRow hover key={trns.consignmentId}>
                        <StyledTableCell style={{ fontSize: '11px' }}>{trns.serialNumber}</StyledTableCell>
                        <StyledTableCell style={{ fontSize: '11px' }}>{trns.consignmentId}</StyledTableCell>
                        <StyledTableCell style={{ fontSize: '11px' }}>{trns.billName}</StyledTableCell>
                        <StyledTableCell style={{ fontSize: '11px' }}>{trns.hsnCode}</StyledTableCell>
                        <StyledTableCell style={{ fontSize: '11px' }}>{trns.taxableValue}</StyledTableCell>
                        <StyledTableCell style={{ fontSize: '11px' }}>{trns.billAmount}</StyledTableCell>
                        <StyledTableCell style={{ fontSize: '11px' }}>{trns.cgstRate}</StyledTableCell>
                        <StyledTableCell style={{ fontSize: '11px' }}>{trns.cgstAmt}</StyledTableCell>
                        <StyledTableCell style={{ fontSize: '11px' }}>{trns.sgstRate}</StyledTableCell>
                        <StyledTableCell style={{ fontSize: '11px' }}>{trns.sgstAmt}</StyledTableCell>
                        <StyledTableCell style={{ fontSize: '11px' }}>{trns.igstRate}</StyledTableCell>
                        <StyledTableCell style={{ fontSize: '11px' }}>{trns.igstAmt}</StyledTableCell>
                        <StyledTableCell style={{ fontSize: '11px' }}>{trns.totalBillAmount}</StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </ItemPap>
          </div>
        </Dialog>
      </div >

      <Snackbar open={open} message={message} severity={severit} onClose={handleClose} />
      {/* //////////////////////..................input designs.......................... */}
      <Home />
      <div style={{ paddingLeft: '100px' }} className='App'>
        {loading ?
          <div className="loaderCss">
            <HashLoader
              color={"#296cbc"}
              loading={loading}
              size={50}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
          </div> :
          <ItemPap >
            <Grid container>
              <Grid item xs={8}>
                <div className='Billingtitleclr' style={{ color: 'red', fontWeight: 'bold', fontSize: '23px', marginTop: '1%', marginBottom: '1%', }}><center>INVOICE COPY DOWNLOAD</center></div>
                <Row>
                  <Col>
                    <Form.Check style={mystyle1} checked={radiovalue === '1'} onChange={radiovalueOnchange} inline label='Job No' value={'1'} type='radio' />
                    <Form.Check style={mystyle1} checked={radiovalue === '2'} onChange={radiovalueOnchange} inline label='GST BillNo' value={'2'} type='radio' />
                  </Col>
                </Row>
                <br></br>
                <Row>
                  <Col xs={1}></Col>
                  <Col xs={2}><label style={mystyle1}>{gettitle()}</label></Col>
                  <Col xs={1}>
                    <Form.Control autoFocus tabIndex={1} size="sm" type="text" id='jobBillId' style={mystyle} onKeyDown={jobNokeydown}
                      value={invcpy_values.jobBIllNo} onChange={jobBillhandlechange} isInvalid={error.jobBIllNo} />
                  </Col>
                  <Col xs={2}></Col>
                  {/*  */}
                  <Col xs={2}><label hidden={airlinse} style={mystyle1}>{ShipmentTitl()}</label></Col>
                  <Col xs={2}>
                    <Form.Control hidden={airlinse} size="sm" type="text" style={mystyle}  tabIndex={4}
                      value={invcpy_values.vessel_Airlines} onChange={AirVesselhandlechange} isInvalid={!invcpy_values.vessel_Airlines} />
                  </Col>
                </Row>
                <Row className="mt-1">
                  <Col xs={1}></Col>
                  <Col xs={2}><label style={mystyle1}>Bill PrintTo</label></Col>
                  <Col xs={2}>
                    <Form.Select size="sm"tabIndex={2} style={mystyle} id='billprintTo' value={invcpy_values.printto} onChange={printtohandlechange}>
                      <option value='-1'>---select---</option>
                      {details2.map(trns => (
                        <option value={trns.billPaidTo}>{trns.billPaidTo}</option>
                      ))}
                    </Form.Select>
                  </Col>
                  <Col xs={1}></Col>
                  {/*  */}
                  <Col xs={2}><label hidden={firstCarrier} style={mystyle1}>{ShipmentVolFirst()}</label></Col>
                  <Col xs={2}>
                    <Form.Control hidden={firstCarrier} size="sm" type="text" style={mystyle} tabIndex={5}
                      value={invcpy_values.firstCarrier_Volume} onChange={FirstCarrier_Volhandlechange} isInvalid={!invcpy_values.firstCarrier_Volume} />
                  </Col>
                </Row>
                <Row className="mt-1">
                  <Col xs={1}></Col>
                  <Col xs={2}> <label style={mystyle1}>Voucher Type</label></Col>
                  <Col xs={2}>
                    <Form.Select size="sm" tabIndex={3} style={mystyle} id='vouchertype' value={invcpy_values.vouchertype} onChange={vouchertypehandlechange}>
                      <option value='-1'>---select---</option>
                      {details5.map((trns) => (
                        <option value={trns.voucherType}>{trns.voucherType}</option>
                      ))}
                    </Form.Select>
                  </Col>
                  <Col xs={1}></Col>
                  {/*  */}
                  <Col xs={2}><label hidden={mode_ofAWB} style={mystyle1}>Mode of AWB</label></Col>
                  <Col xs={2}>
                    <Form.Control hidden={mode_ofAWB} size="sm" type="text" style={mystyle} tabIndex={6}
                      value={invcpy_values.modeOf_AWB} onChange={modeOfAWBhandlechange} isInvalid={!invcpy_values.modeOf_AWB} />
                  </Col>
                </Row>
                <Row className="mt-1">
                  <Col xs={1}></Col>
                  <Col xs={2}> <label hidden={shiper_hide} style={mystyle1}>Shipper Invoice No</label></Col>
                  <Col xs={2}>
                    <Form.Control hidden={shiper_hide} size="sm" tabIndex={7} style={mystyle} value={invcpy_values.shipperINVno} onChange={ShipperInvNohandlechange}
                    />
                  </Col>
                  <Col xs={1}></Col>
                  {/*  */}
                  <Col xs={2}><label hidden={shiper_hide} style={mystyle1}>Shipper Invoice Date</label></Col>
                  <Col xs={2}>
                    <Form.Control hidden={shiper_hide} size="sm" type="date" style={mystyle} tabIndex={8}
                      value={invcpy_values.shipperINVdate} onChange={ShipperInvDateHandlechange} />
                  </Col>
                </Row>
                <Row className="mt-3 mb-2">
                  <Col lg={3}></Col>
                  <Col lg={6}><Button onClick={showBTnOpen} style={{ fontFamily: 'Times New Roman' }} variant="success" size="sm">{showProcs ? 'processing...' : 'Show'}</Button>{" "}
                    <Button variant="warning" size="sm" style={{ fontFamily: 'Times New Roman' }} onClick={RefreshBtn}>{refreshProcs ? 'processing...' : 'Refresh'}</Button>{" "}
                    <Button variant="primary" size="sm" style={{ fontFamily: 'Times New Roman' }} disabled={dwmldbillDis} onClick={downldBillhandleClickOpen}>{dwnldBillCopyProcs ? 'processing...' : 'Download Bill Copy'}</Button>
                  </Col>
                  <Col lg={3}></Col>
                </Row>
              </Grid>
              <Grid item xs={4}>
                <ItemPap1>
                  <Typography color={"darkblue"} fontWeight={"bolder"} variant={"h6"} style={{ marginTop: "-1rem" }}>
                    Summary
                  </Typography>
                  <Row>
                    <Col xs={3} ><Form.Label style={{ fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>TotalJobNo</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{ fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{invcpy_values.totalJobNo}</Form.Label></Col>
                  </Row>
                  <Row>
                    <Col xs={3} ><Form.Label style={{ fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>TaxableValue</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{ fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{invcpy_values.taxablevalue}</Form.Label></Col>
                  </Row>
                  <Row>
                    <Col xs={3} ><Form.Label style={{ fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>CGSTAmount</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{ fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{invcpy_values.cgstAmt}</Form.Label></Col>
                  </Row>
                  <Row>
                    <Col xs={3} ><Form.Label style={{ fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>SGSTAmount</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{ fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{invcpy_values.sgstAmt}</Form.Label></Col>
                  </Row>
                  <Row>
                    <Col xs={3} ><Form.Label style={{ fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>IGSTAmount</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{ fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{invcpy_values.igstAMt}</Form.Label></Col>
                  </Row>
                  <Row>
                    <Col xs={3} ><Form.Label style={{ fontFamily: 'Times New Roman', justifyContent: 'left', color: "black", fontWeight: "bolder", }}>TotalBilling Amount</Form.Label></Col>
                    <Col xs={3} ><Form.Label style={{ justifyContent: 'left', color: "black", fontWeight: "bolder", }}>:</Form.Label></Col>
                    <Col><Form.Label style={{ fontFamily: 'Times New Roman', justifyContent: 'left', color: "red", fontWeight: "bolder", }}>{invcpy_values.totalAMt}</Form.Label></Col>
                  </Row>
                </ItemPap1>
              </Grid>
            </Grid>
            <ItemPap1>
              <TableContainer sx={{ height: 300 }} className="mt-1 scrollbarPrime">
                <Table stickyHeader className="table table-bordered">
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell>SlNo</StyledTableCell>
                      <StyledTableCell>JobNo{jobnoSrch()}</StyledTableCell>
                      <StyledTableCell>GST_BillNo{gstBillNoSrch()}</StyledTableCell>
                      <StyledTableCell>ImporterName{importerSrch()}</StyledTableCell>
                      <StyledTableCell>ForwarderName</StyledTableCell>
                      <StyledTableCell>Mode{modeSrch()}</StyledTableCell>
                      <StyledTableCell>TotalPkg</StyledTableCell>
                      <StyledTableCell>Gross_Wt</StyledTableCell>
                      <StyledTableCell>Bill_Paid_By</StyledTableCell>
                      <StyledTableCell>Bill_Paid_Date</StyledTableCell>
                      <StyledTableCell>TaxableValue</StyledTableCell>
                      <StyledTableCell>CGST_Amount</StyledTableCell>
                      <StyledTableCell>SGST_Amount</StyledTableCell>
                      <StyledTableCell>IGST_Amount</StyledTableCell>
                      <StyledTableCell>Total_BillAmount</StyledTableCell>
                      <StyledTableCell>MAWB/MBL</StyledTableCell>
                      <StyledTableCell>HAWB/HBL</StyledTableCell>
                      <StyledTableCell>ContainerNo</StyledTableCell>
                      <StyledTableCell>shipmentMode</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {FilteredDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((trns, index) => (
                        <TableRow hover onClick={() => SinglejobsummaryAssign(trns)}>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.serialNumber}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.consignmentId}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.invoiceNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.iecName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.fwdName}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.transitMode}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.noOfPkg}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.grNetWeight}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.billPaidBy}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.billPaidDate}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.billAmount}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.cgstAmt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.sgstAmt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.igstAmt}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.totalBillAmount}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.mawbNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.hawbNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.containerNo}</StyledTableCell>
                          <StyledTableCell style={{ fontSize: '10px', fontWeight: 'bold' }}>{trns.shipmentMode}</StyledTableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                showFirstButton
                showLastButton
                component='div'
                count={FilteredDetails.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onChangeRowsPerpage={handleChangeRowsPerPage}
              />
            </ItemPap1>
          </ItemPap>
        }
      </div>
    </div >
  );
}

export default InvoiceBillDownload;
